module.exports = __webpack_public_path__ + "r-v3/img/ml_02_00.8c0ccf9c.jpg";